/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import ErrorBoundary from '@jira/platform__error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { fg } from '@atlassian/jira-feature-gating';
import type { KnowledgeBaseNav, KnowledgeBaseNavWithUseResource } from './ui/index.tsx';

const LazyKbNav = lazyForPaint<typeof KnowledgeBaseNav>(
	() =>
		import(/* webpackChunkName: "async-kb-nav" */ './ui/index.tsx').then(
			({ KnowledgeBaseNav }) => KnowledgeBaseNav,
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

const LazyKbNavWithUseResource = lazyForPaint<typeof KnowledgeBaseNavWithUseResource>(
	() =>
		import(/* webpackChunkName: "async-kb-nav-with-use-resource" */ './ui/index.tsx').then(
			({ KnowledgeBaseNavWithUseResource }) => KnowledgeBaseNavWithUseResource,
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncKbNav = (): React.JSX.Element => {
	return (
		<ErrorBoundary id="horizontal-jsm-kb-nav" packageName="jira-horizontal-nav-jsm-knowledge-base">
			<Placeholder name="horizontal-jsm-kb-nav">
				{fg('jsm-kb-articles-functional') ? <LazyKbNavWithUseResource /> : <LazyKbNav />}
			</Placeholder>
		</ErrorBoundary>
	);
};
